import { useEffect, useRef, useState } from "react";
import { useGetCustomers } from "../../../hooks/api/queries";

export const useCustomerSelectField = ({ value }) => {
  const [inputValue, setInputValue] = useState(value || "");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const [queryParams, setQueryParams] = useState({
    query: "",
    all_business: 1,
    per_page: 50,
  });

  const containerRef = useRef(null);

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target))
        setIsDropdownOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const { data, isLoading } = useGetCustomers({
    isEnabled: isSearchEnabled,
    queryParams,
  });

  const handleInputChange = (searchValue) => {
    setInputValue(searchValue);
    setQueryParams((prev) => ({ ...prev, query: searchValue }));
    setIsSearchEnabled(true);
    setIsDropdownOpen(true);
  };

  const handleSelect = (customer, onControllerChange, onChange) => {
    setInputValue(customer?.full_name || "");
    setIsDropdownOpen(false);
    setIsSearchEnabled(false);
    onControllerChange(customer?.id);
    onChange(customer?.id, customer);
  };

  const handleFocus = () => {
    if (queryParams.query) setIsDropdownOpen(true);
  };

  return {
    containerRef,
    inputValue,
    isDropdownOpen,
    isLoading,
    customers: data?.data || [],
    handleInputChange,
    handleSelect,
    handleFocus,
  };
};
